import { createStore, Provider, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { DevTools, useAtomsDevtools } from 'jotai-devtools';

import { isDevelopment } from '@watershed/config/env';
import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

export const jotaiStore = createStore();

export const enableJotaiDebugAtom = atomWithStorage(
  'wsEnableJotaiDebug',
  getPublicRuntimeConfig('NEXT_PUBLIC_ENABLE_JOTAI_DEVTOOLS') === 'true',
  undefined,
  { getOnInit: true }
);

function JotaiUseDevtools() {
  useAtomsDevtools('dashboard-atoms', {
    enabled: true,
    store: jotaiStore,
    // we could set this to true with a command pallete action if it gets interesting to see the internals of librrary atoms
    shouldShowPrivateAtoms: false,
  });
  return null;
}

function JotaiDebug() {
  const [enableJotaiDebug] = useAtom(enableJotaiDebugAtom);

  // separately check node env here so next / webpack can treeshake and remove the code entirely when not in dev
  return enableJotaiDebug && isDevelopment() ? (
    <>
      <DevTools store={jotaiStore} />
      <JotaiUseDevtools />
    </>
  ) : null;
}

export function JotaiProvider({
  children,
  store,
}: {
  children: React.ReactNode;
  store?: typeof jotaiStore;
}) {
  return (
    <Provider store={store ?? jotaiStore}>
      <JotaiDebug />
      {children}
    </Provider>
  );
}
